import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
    CreateCheckoutSettings,
    UpdateCheckoutSettings,
} from "@/types/booking-checkout-settings";
import { bookingCheckoutSettingsService } from "@/services/ServiceRegistry";

export const checkoutSettingsKeys = {
    all: ["checkout-settings"] as const,
    details: () => [...checkoutSettingsKeys.all, "detail"] as const,
};

export const useBookingCheckoutSettings = (hotelId?: string) => {
    return useQuery({
        queryKey: checkoutSettingsKeys.details(),
        queryFn: () => bookingCheckoutSettingsService.getSettings(),
        enabled: !!hotelId,
    });
};

export const useCreateBookingCheckoutSettings = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: CreateCheckoutSettings) =>
            bookingCheckoutSettingsService.createSettings(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: checkoutSettingsKeys.details() });
        },
    });
};

export const useUpdateBookingCheckoutSettings = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (data: UpdateCheckoutSettings) =>
            bookingCheckoutSettingsService.updateSettings(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: checkoutSettingsKeys.details() });
        },
    });
};
